/**
 * TORCHTORCH Universal Product Card JavaScript
 * =============================================
 * Ajaxカート機能、クイックビュー連携
 */

(function () {
  'use strict';

  /**
   * カートに商品を追加（Ajax）
   * @param {string|number} variantId - バリアントID
   * @param {number} quantity - 数量
   * @returns {Promise<any>}
   */
  const univAddToCart = function (variantId, quantity = 1) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(String(variantId), 10),
          quantity: quantity
        }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function (data) {
        // カートアイコンの数量を更新
        updateCartCount();

        // カスタムイベントを発火
        document.dispatchEvent(new CustomEvent('univ:cart:added', {
          detail: { items: data.items }
        }));

        return data;
      });
  };

  // グローバルに公開
  /** @type {any} */ (window).univAddToCart = univAddToCart;

  /**
   * カートの数量を更新
   */
  function updateCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        // カートカウンターを更新
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(function (el) {
          if (el instanceof HTMLElement) {
            el.textContent = String(cart.item_count);
            el.style.display = cart.item_count > 0 ? '' : 'none';
          }
        });

        // カスタムイベントを発火
        document.dispatchEvent(new CustomEvent('univ:cart:updated', {
          detail: { cart: cart }
        }));
      })
      .catch(function (error) {
        console.error('Failed to update cart count:', error);
      });
  }

  /**
   * Add to Cartボタンのイベント設定
   */
  function initAddToCartButtons() {
    document.addEventListener('click', function (e) {
      const target = /** @type {Element} */ (e.target);
      if (!target) return;

      const button = /** @type {HTMLButtonElement|null} */ (target.closest('[data-add-to-cart]'));
      if (!button) return;

      e.preventDefault();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const isIcon = !!button.querySelector('svg');
      const originalHTML = button.innerHTML;

      button.disabled = true;
      button.classList.add('is-adding');

      if (isIcon) {
        button.innerHTML = '<span class="loading-spinner"></span>';
      } else {
        button.textContent = 'Adding...';
      }

      univAddToCart(variantId, 1)
        .then(function () {
          button.classList.remove('is-adding');
          button.classList.add('is-added');

          if (isIcon) {
            button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          } else {
            button.textContent = '✓ Added';
          }

          // 2秒後に元に戻す
          setTimeout(function () {
            button.classList.remove('is-added');
            button.innerHTML = originalHTML;
            button.disabled = false;
          }, 2000);
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          button.classList.remove('is-adding');

          if (isIcon) {
            button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
          } else {
            button.textContent = 'Error';
          }

          setTimeout(function () {
            button.innerHTML = originalHTML;
            button.disabled = false;
          }, 1500);
        });
    });
  }

  /**
   * バリアントスウォッチのイベント設定
   */
  function initVariantSwatches() {
    document.addEventListener('click', function (e) {
      const target = /** @type {Element} */ (e.target);
      if (!target) return;

      const swatch = target.closest('.univ-product-card__swatch');
      if (!swatch) return;

      e.preventDefault();

      const card = swatch.closest('.univ-product-card');
      if (!(card instanceof HTMLElement)) return;

      const productHandle = card.dataset.productHandle;
      const colorValue = /** @type {HTMLElement} */ (swatch).title;

      // カスタムイベントを発火
      document.dispatchEvent(new CustomEvent('univ:swatch:selected', {
        detail: {
          productHandle: productHandle,
          colorValue: colorValue,
          card: card
        }
      }));
    });
  }

  /**
   * 初期化
   */
  function init() {
    initAddToCartButtons();
    initVariantSwatches();
  }

  // DOMContentLoaded後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
